import { actionGenerator } from 'shared/utils/redux/actionGenerator';

import { ECpdDraftStatus, ICpdLabelModalState, ICpdPrelandingModalState } from '../../types/cpd/cpd';

export enum ECPDActionTypes {
  setAvailableCpd = 'cpd/setAvailableCpd',
  setLabelModalOpen = 'cpd/setLabelModalOpen',
  setPrelandingModalOpen = 'cpd/setPrelandingModalOpen',
  setCpdDraftId = 'cpd/setCpdDraftId',
  setCpdDraftStatus = 'cpd/setCpdDraftStatus',
  setCpdSource = 'cpd/setCpdSource',
  setCpdCianSource = 'cpd/setCpdCianSource',
  setCustomCpdDealType = 'cpd/setCustomCpdDealType',
}

export const setAvailableCpd = actionGenerator<ECPDActionTypes.setAvailableCpd, boolean>(
  ECPDActionTypes.setAvailableCpd,
);
export const setLabelModalOpen = actionGenerator<ECPDActionTypes.setLabelModalOpen, ICpdLabelModalState>(
  ECPDActionTypes.setLabelModalOpen,
);
export const setPrelandingModalOpen = actionGenerator<ECPDActionTypes.setPrelandingModalOpen, ICpdPrelandingModalState>(
  ECPDActionTypes.setPrelandingModalOpen,
);
export const setCpdDraftId = actionGenerator<ECPDActionTypes.setCpdDraftId, number>(ECPDActionTypes.setCpdDraftId);
export const setCpdDraftStatus = actionGenerator<ECPDActionTypes.setCpdDraftStatus, ECpdDraftStatus>(
  ECPDActionTypes.setCpdDraftStatus,
);
export const setCpdSource = actionGenerator<ECPDActionTypes.setCpdSource, string>(ECPDActionTypes.setCpdSource);
export const setCpdCianSource = actionGenerator<ECPDActionTypes.setCpdCianSource, string>(
  ECPDActionTypes.setCpdCianSource,
);
export const setCustomCpdDealType = actionGenerator<ECPDActionTypes.setCustomCpdDealType, string>(
  ECPDActionTypes.setCustomCpdDealType,
);

export type TCPDActions =
  | ReturnType<typeof setAvailableCpd>
  | ReturnType<typeof setLabelModalOpen>
  | ReturnType<typeof setPrelandingModalOpen>
  | ReturnType<typeof setCpdDraftId>
  | ReturnType<typeof setCpdDraftStatus>
  | ReturnType<typeof setCpdSource>
  | ReturnType<typeof setCpdCianSource>
  | ReturnType<typeof setCustomCpdDealType>;
